import { useState } from 'react';
import styled from 'styled-components';
import { FocusableRadioIcon } from './FocusableRadioIcon';

type RadioInputProps = {
  name: string;
  value: string;
  isChecked: boolean;
  onChange: () => void;
  id: string;
  tabIndex?: -1;
};

export const RadioInput = ({
  id,
  name,
  value,
  isChecked,
  onChange,
  tabIndex,
}: RadioInputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <RelativeWrapper onClick={onChange}>
      <FocusableRadioIcon isChecked={isChecked} isFocused={isFocused} />
      <HiddenRadioInput
        id={id}
        type="radio"
        name={name}
        value={value}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        checked={isChecked}
        onChange={onChange}
        tabIndex={tabIndex}
      />
    </RelativeWrapper>
  );
};

const HiddenRadioInput = styled.input`
  /* This is the input that is hidden to provide better styling, but provides all accessibility features of radio input */
  opacity: 0;
  position: absolute;
`;

const RelativeWrapper = styled.div`
  position: relative;
`;
